$(window).on("load", function () {
	setTimeout(function () {
		$(".invisible-before-full-load").removeClass("invisible");
		$("preloader").hide();
	},1);
});
